const ResultInRange = [
  "Sugar",
  "Protein",
  "Bili",
  "Ketone",
  "Blood",
  "Urobi",
  "Nitrate",
  "Leukocytes",
];

export default ResultInRange;
